module.exports = __webpack_public_path__ + "img/icone-distribution.df638d06.svg";